export default "__VITE_ASSET__uCn7e4cT__"